'use client';

import { useState } from 'react';
import ModalForm from '@/components/Modal/Modal';

interface LeadModalButtonProps {
  label: string;
  className?: string;
  tag?: string;
  color?: 'green' | 'blue' | 'violet';
}

export default function LeadModalButton({
  label,
  className,
  tag = 'pidgotovchi_kursy',
  color = 'green',
}: LeadModalButtonProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button type="button" onClick={() => setIsOpen(true)} className={className}>
        {label}
      </button>
      {isOpen && (
        <ModalForm
          closeForm={() => setIsOpen(false)}
          btnMeta={{ tag }}
          color={color}
          showDate={false}
        />
      )}
    </>
  );
}
